import React from 'react';
import './PagerBar.css';

interface PagerBarProps {
  currentPage: number;
  totalPages: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
  onItemsPerPageChange: (itemsPerPage: number) => void;
}

const PagerBar: React.FC<PagerBarProps> = ({
  currentPage,
  totalPages,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange
}) => {
  const handleFirstPage = () => {
    if (currentPage > 1) {
      onPageChange(1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handleLastPage = () => {
    if (currentPage < totalPages) {
      onPageChange(totalPages);
    }
  };

  const handleItemsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newItemsPerPage = parseInt(event.target.value, 10);
    onItemsPerPageChange(newItemsPerPage);
  };

  // Don't render if there's only one page and default settings
  if (totalPages <= 1 && itemsPerPage === 10) {
    return null;
  }

  return (
    <div className="pager-bar">
      <button
        className="pager-btn pager-btn-first"
        onClick={handleFirstPage}
        disabled={currentPage === 1}
        title="First page"
        aria-label="Go to first page"
      >
        |&lt;
      </button>
      
      <button
        className="pager-btn pager-btn-previous"
        onClick={handlePreviousPage}
        disabled={currentPage === 1}
        title="Previous page"
        aria-label="Go to previous page"
      >
        &lt;&lt;
      </button>
      
      <div className="pager-dropdown-container">
        <select
          className="pager-dropdown"
          value={itemsPerPage}
          onChange={handleItemsPerPageChange}
          title="Items per page"
          aria-label="Select items per page"
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>
      </div>
      
      <button
        className="pager-btn pager-btn-next"
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
        title="Next page"
        aria-label="Go to next page"
      >
        &gt;&gt;
      </button>
      
      <button
        className="pager-btn pager-btn-last"
        onClick={handleLastPage}
        disabled={currentPage === totalPages}
        title="Last page"
        aria-label="Go to last page"
      >
        &gt;|
      </button>
    </div>
  );
};

export default PagerBar;
